const $ = window.jQuery

/**
 * Enables 'MWB WooCommerce' plugin specific scripting
 */
const WooCommerce = {

    /**
     * Initialise functionality
     */
    init() {

        let vm = this

        vm.handleQuantityInputs()
        vm.handleAutoCartUpdate()
        vm.handleVariationImageCarousel()

        // On element change via AJAX, reattach listeners
        $(document.body).on('wc_fragments_refreshed', vm.handleQuantityInputs)

    },

    /**
     * Handle increment/decrement buttons for quantity pickers
     */
    handleQuantityInputs() {

        $('.quantity').each( function() {

            const $quantityEl   = $(this)
            const $inputEl      = $quantityEl.find('input[type="number"]')

            // Reset any previous "click" event bindings
            $quantityEl.find('.quantity-increment, .quantity-decrement').off('click')

            // Set "click" event bindings for incrementing
            $quantityEl.find('.quantity-increment').on('click', function() {
                $inputEl.get(0).stepUp()
                $inputEl.trigger('change')
            })

            // Set "click" event bindings for decrementing
            $quantityEl.find('.quantity-decrement').on('click', function() {
                $inputEl.get(0).stepDown()
                $inputEl.trigger('change')
            })

        })

    },

    /**
     * Handle automatic cart updating, to remove need for "update cart" button
     */
    handleAutoCartUpdate() {

        let cartUpdateTimeout

        $('.woocommerce').on('change', 'input.qty', function() {

            // New change, reset last delayed call
            if (cartUpdateTimeout !== undefined) clearTimeout(cartUpdateTimeout)

            cartUpdateTimeout = setTimeout(() => {
                $('[name="update_cart"]').trigger('click')
            }, 500)

        })

    },

    /**
     * Change current carousel image to selected variation's
     */
    handleVariationImageCarousel() {

        const   vm          = this,
                $form       = $('form.variations_form'),
                variations  = $form.data('product_variations')

        // only run if there's a variation form or variations
        if ( ! $form.length || ! variations ) return;

        // scroll to image on page load (Slick was having issues initialising with this instantly)
        $(document).ready(function() {
            setTimeout(function() {
                vm.scrollCarouselToVariationImage(variations, $form)
            }, 1000)
        })

        // scroll to variation image on attribute change
        $form.find('input[name^="attribute_"], select[name^="attribute_"]').change(function() {
            vm.scrollCarouselToVariationImage(variations, $form)
        })

    },

    /**
     * Scroll carousel to selected variation image
     *
     * @param {array} variations  List of variations
     * @param {jQuery el} $form Form element containing variation inputs
     */
    scrollCarouselToVariationImage(variations, $form) {

        let availableVariations = this.getAvailableVariations(variations, $form.serializeArray())

        // only scroll to image if there are any possible variations
        if ( ! Object.keys(availableVariations).length ) return

        // only scroll to image if variations have been filtered down
        if ( variations.length === availableVariations.length ) return

        const variation = availableVariations[0]

        // check variation has an image
        if ( false == ( variation.image_id || false ) ) return

        // find matching image in carousel
        const $carousel = $('#product-images[data-slick]')
        const $images   = $carousel.find('.slick-slide:not(.slick-cloned) img')
        const $image    = $carousel.find(`.slick-slide:not(.slick-cloned) img[data-image-id="${variation.image_id}"]`)

        // set slider to image matching variation's image id
        $carousel.slick('slickGoTo', $images.index($image))

    },

    /**
     * Get available variations from choices
     *
     * @param {array} variations List of variations
     * @param {array} selected Serialized form (see `serializeArray`)
     */
    getAvailableVariations(variations, selected) {

        // filter out non-attribute form fields
        selected = selected.filter(choice => choice.name.startsWith('attribute_') && choice.value)

        return variations
            .filter(variation => {

                let valid = true

                // go through selected attributes against variation, quit once there's an invalid combination
                selected.some(choice => {
                    if ((variation.attributes[choice.name] || false) !== choice.value) {
                        valid = false
                        return true
                    }
                })

                return valid

            })

    },

}

export default WooCommerce;